import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { StoreUtil } from 'doctivity-shared/utils';

import { AnalyticsTabs } from 'components';
import { UsageReportTab } from 'components/usage/UsageReportTab';
import { UsageCompareTab } from 'components/usage/UsageCompareTab';

const styles = (theme) => ({
  subheader: {
    padding: `0 ${theme.spacing(3)}`,
    marginTop: theme.spacing(1),
  },
});

// `tab` is supplied by the route ('usage' at /usage, 'compare' at /usage/compare).
// The Activity Log tab is its own page/route (ActivityLogPage at /activity); the
// shared AnalyticsTabs bar links the three together.
function UsageAnalyticsPageBase({ classes, tab = 'usage' }) {
  const clientId = useSelector(({ app }) => app.selectedClient);
  const clientsList = useSelector(
    (state) => StoreUtil.getData(StoreUtil.get(state.clients, StoreUtil.COMMON_LIST)) || []
  );
  const clientName = (clientsList.find((c) => c.id === clientId) || {}).name;

  return (
    <>
      <AnalyticsTabs tab={tab} />

      {tab === 'usage' && (
        <div className={classes.subheader}>
          {clientId ? (
            <Typography variant='subtitle1'>
              Client:{' '}
              <span style={{ fontWeight: 700, color: '#000000' }}>
                {clientName || `#${clientId}`}
              </span>
            </Typography>
          ) : (
            <Typography variant='subtitle1' color='textSecondary'>
              Select a client from the top navigation to view its metrics.
            </Typography>
          )}
        </div>
      )}

      {tab === 'usage' && clientId && <UsageReportTab clientId={clientId} />}
      {tab === 'compare' && <UsageCompareTab />}
    </>
  );
}

UsageAnalyticsPageBase.propTypes = {
  classes: PropTypes.object.isRequired,
  tab: PropTypes.string,
};

const styled = withStyles(styles)(UsageAnalyticsPageBase);
export { styled as UsageAnalyticsPage };
